module.exports = __webpack_public_path__ + "static/sprite-c1918abe274055a8e4426289f8b21c1b.jpg";